import StructureMeta from './StructureMeta.js';

export default class StructureMetaList {
	/** @param {StructureMeta[]} structureMetas */
	constructor(structureMetas) {
		this.structures = structureMetas;
	}

	size() {
		return this.structures.length;
	}

	/** @returns {StructureMeta[]} */
	getStructures() {
		return this.structures;
	}

	/** @returns {boolean} whether the server copies these analytes instead of creating them from these fields */
	isImported() {
		return this.structures.length > 0 && this.structures.every(s => s.isImported());
	}

	/** @returns {string[]} */
	getSourceSubstanceIds() {
		return this.structures.map(s => s.sourceSubstanceId);
	}

	containsStructureWithEmptyInjectionName() {
		return this.structures.find(s => typeof s.injectionName != "string" || s.injectionName.trim().length === 0)
	}

	getUniqueInjectionNamesCount() {
		const notNullUniqueNames = new Set();
		for (const structure of this.structures) {
			let injectionName = structure.injectionName;
			if (injectionName != null)
				notNullUniqueNames.add(injectionName.toLowerCase())
		}
		return notNullUniqueNames.size;

	}

	static parseServerJson(json) {
		return new StructureMetaList(json.map(s => StructureMeta.parseServerJson(s)))
	}
}
